import { Injectable } from "@angular/core";

import { dbToBooleans } from "@dffedb/util";

import { SendMailTilForbrugerDataDto } from "./model/send-mail-til-forbruger-data.dto";
import { SendMailTilForbrugerData } from "./model/send-mail-til-forbruger-data.model";
import { SendMailTilForbrugerDto } from "./model/send-mail-til-forbruger.dto";
import { SendMailTilForbruger } from "./model/send-mail-til-forbruger.model";

@Injectable({ providedIn: "root" })
export class SendMailTilForbrugerMapper {
    public dtoToSendMailTilForbrugerData(dto: SendMailTilForbrugerDataDto): SendMailTilForbrugerData {
        const result: SendMailTilForbrugerData = {
            sendMailTilForbruger: this.dtoToSendMailTilForbruger(dto.sendMailTilForbruger)
        };
        return result;
    }

    public dtoToSendMailTilForbruger(dto: SendMailTilForbrugerDto): SendMailTilForbruger {
        const result: SendMailTilForbruger = {
            email: dto.email,
            emailFrabedes: dbToBooleans(dto.emailFrabedes)
        };
        return result;
    }

    public sendMailTilForbrugerDataToDto(model: SendMailTilForbrugerData): SendMailTilForbrugerDataDto {
        const result: SendMailTilForbrugerDataDto = {
            sendMailTilForbruger: this.sendMailTilForbrugerToDto(model.sendMailTilForbruger)
        };
        return result;
    }

    public sendMailTilForbrugerToDto(model: SendMailTilForbruger): SendMailTilForbrugerDto {
        const result: SendMailTilForbrugerDto = {
            email: model.email,
            emailFrabedes: model.emailFrabedes
        };
        return result;
    }
}
